"use client";

import { ChevronDown } from "lucide-react";
import { useState } from "react";
const faqs = [{
  id: 1,
  question: "What is ABA therapy?",
  answer: "Applied Behavior Analysis (ABA) is an evidence-based therapy approach that helps children with autism and developmental needs improve communication, social skills, and daily living activities through structured teaching and positive reinforcement."
}, {
  id: 2,
  question: "How do I know if my child qualifies for ABA services?",
  answer: "Most children with a diagnosis of autism spectrum disorder (ASD) or related developmental conditions qualify for ABA therapy. We conduct comprehensive behavior assessments to determine eligibility and create individualized treatment plans. Contact us to discuss your child's specific needs."
}, {
  id: 3,
  question: "Does insurance cover ABA therapy?",
  answer: "Many insurance plans, including Medicaid and most private insurers in Florida, cover ABA therapy for children with autism. We work with major insurance providers and can help you understand your coverage and benefits. Visit our Insurance & Funding page for more details."
}, {
  id: 4,
  question: "Where do you provide services?",
  answer: "We provide ABA therapy services throughout Miami-Dade County, including in-home sessions, school-based support, and clinic settings. Our bilingual team serves families in diverse communities across the Miami area."
}, {
  id: 5,
  question: "What is the role of a BCBA?",
  answer: "A Board Certified Behavior Analyst (BCBA) is a licensed professional who designs, oversees, and evaluates your child's ABA therapy program. Our BCBAs provide clinical supervision, conduct assessments, train therapists and families, and adjust treatment plans to ensure the best outcomes."
}, {
  id: 6,
  question: "How can parents and caregivers participate in therapy?",
  answer: "Parent and caregiver involvement is essential to successful therapy. We offer dedicated parent training sessions to teach you strategies for supporting your child's progress at home. You'll learn techniques to reinforce skills and manage behaviors in everyday situations."
}, {
  id: 7,
  question: "How long does ABA therapy typically last?",
  answer: "The duration of ABA therapy varies for each child based on their individual needs, goals, and progress. Some children benefit from intensive therapy for several years, while others may need shorter-term support. Our BCBAs regularly assess progress and adjust treatment duration accordingly."
}, {
  id: 8,
  question: "Do you offer bilingual services?",
  answer: "Yes! We are proud to offer bilingual services in English and Spanish to better serve Miami's diverse community. Our culturally sensitive approach ensures families feel comfortable and understood throughout the therapy process."
}];
export default function FAQ() {
  const [openId, setOpenId] = useState<number | null>(null);
  const toggleFaq = (id: number) => {
    setOpenId(openId === id ? null : id);
  };
  return <section id="faq" className="dark bg-background text-foreground py-16 px-4">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-display font-bold text-3xl lg:text-4xl mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-foreground/80 text-lg">
            Find answers to common questions about our ABA therapy services
          </p>
        </div>

        <div className="space-y-0">
          {faqs.map((faq, i) => <div key={faq.id} data-index={i} className="border-b border-border/30 last:border-b-0">
              <button onClick={() => toggleFaq(faq.id)} className="w-full py-6 flex items-start justify-between gap-6 text-left group hover:bg-foreground/5 transition-colors duration-200 px-4 rounded-md" aria-expanded={openId === faq.id}>
                <span className="font-semibold text-lg leading-relaxed pr-4">
                  {faq.question}
                </span>
                <ChevronDown className={`size-5 shrink-0 mt-1 text-foreground/60 transition-transform duration-300 ${openId === faq.id ? "rotate-180" : ""}`} />
              </button>
              <div className={`overflow-hidden transition-all duration-300 ease-smooth ${openId === faq.id ? "max-h-96 opacity-100" : "max-h-0 opacity-0"}`}>
                <div className="pb-6 px-4 text-foreground/80 leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}